import { PDFDownloadLink } from '@react-pdf/renderer';
import Birthday from './Birthday';

const BirthdayQuotation = ({ pdfData }) => {
  const fileName = 'BirthdayQuotation.pdf';

  return (
    <div className="download-link">
      <center>
        <PDFDownloadLink
          document={<Birthday pdfData={pdfData.quotation_details} mob_no_status={pdfData.mob_no_status}/>}
          fileName={fileName}
          style={{ textDecoration: 'none' }}
        >
          {({ loading }) => (
            <button className="btn btn-success text-white my-3">
              {loading ? 'Preparing document...' : 'Download Birthday Quotation'}
            </button>
          )}
        </PDFDownloadLink>
      </center>
    </div>
  );
};

export default BirthdayQuotation;
